import { createFileRoute } from '@tanstack/react-router'

import { AccountingContractors } from '@/features/accounting/pages/contractors'
import Head from '@/lib/navigation/head'

/** The page owns its wrapper and sticky header: the "Add contractor" button lives in the header row. */
function ContractorsRoute() {
  return (
    <>
      <Head>
        <title>Contractors & vendors | Nonresident Tax</title>
      </Head>
      <AccountingContractors />
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/contractors')({
  component: ContractorsRoute,
})
